import { render, staticRenderFns } from "./SideMenuAlert.vue?vue&type=template&id=e7351788&scoped=true&"
import script from "./SideMenuAlert.vue?vue&type=script&lang=ts&"
export * from "./SideMenuAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuAlert.vue?vue&type=style&index=0&id=e7351788&lang=scss&scoped=true&"
import style1 from "./SideMenuAlert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7351788",
  null
  
)

export default component.exports